var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.btnFlag)?_c('div',{on:{"click":_vm.scrollup_top}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"scrollup button-circle",attrs:{"title":"Go Top","href":"#"}},[_c('i',{staticClass:"fas fa-angle-up"})])
}]

export { render, staticRenderFns }